import type { LatLngBounds } from 'leaflet'

export async function fetchAvailabilities(
  bounds: LatLngBounds
): Promise<AvailabilityResponse | null> {
  const route = useRoute()
  return await $fetch<AvailabilityResponse>('/availabilities', {
    method: 'GET',
    baseURL: useRuntimeConfig().public.apiBaseURL,
    query: {
      upperLat: bounds.getNorthEast().lat,
      upperLon: bounds.getNorthEast().lng,
      lowerLat: bounds.getSouthWest().lat,
      lowerLon: bounds.getSouthWest().lng,
      lan: route.params.locale,
    },
  }).catch(() => {
    return null
  })
}
